<script setup>
import { computed } from 'vue'
import GenreGridTile from '@components/genre/genre-grid-tile'

const props = defineProps({
    genres: {
        type: Array,
        default: () => [],
    },
    padded: {
        type: Boolean,
        default: false,
    },
    followedGenreIds: {
        type: Array,
        default: () => [],
    },
    hasOptions: {
        type: Boolean,
        default: true,
    },
})

defineEmits(['toggle-follow'])

const followedGenreIdsSet = computed(() => new Set(props.followedGenreIds))
</script>

<template>
    <div :class="['genre-grid-block', padded && 'genre-grid-block-padded']">
        <GenreGridTile
            v-for="(genre, index) in genres"
            :key="'genre-' + genre.id"
            :genre="genre"
            :index="index"
            :is-following="followedGenreIdsSet.has(genre.id)"
            :has-options="hasOptions"
            @toggle-follow="$emit('toggle-follow', $event)"
        />
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.genre-grid-block {
    display: grid;
    gap: $s-xl;

    &-padded {
        @include sidePadding;
    }

    @include tablet {
        grid-template-columns: repeat(2, 1fr);
    }

    @include desktop {
        grid-template-columns: repeat(4, 1fr);
    }
}
</style>
